import React from "react";
import { Button } from "semantic-ui-react";
import ShowDateTime from "show/components/ShowDateTime";
import { AppointmentPhase } from "../../components";
import { Loading } from "../../components/panels";
import SelectProduct from "../../components/products/SelectProduct";
import { getDocumentCoreApi } from "../../utilities/apiUtils";

interface Props {
  documentId: number
  selectedShows: server.dto.ShowForListInternal[]
  documentType: server.dto.DocumentTypes
  onLinkedShowsSaved: () => void
}

const SelectShowProducts = (props: Props) => {
  const [showWithProducts, setShowWithProducts] = React.useState<server.dto.ShowWithProducts[]>([]);

  const [selection, setSelection] = React.useState<server.dto.LinkShowInstruction[]>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  React.useEffect(() => {
    window.CoreApi.Show.ListShowsWithProducts({
      showIds: props.selectedShows.map(s => s.showId)
    })
      .then(res => {
        setShowWithProducts(res.data.data);
        const newSelection: server.dto.LinkShowInstruction[] = res.data.data
          .map(data => ({
            showId: data.show.showId,
            productIds: data.products.collection.map(prod => prod.productId)
          }));

        setIsLoading(false);
        setSelection(newSelection);
      });
  }, []);

  const selectionMap: Record<number, Set<number>> = selection.reduce((acc, curr) => ({
    ...acc,
    [curr.showId]: new Set(curr.productIds)
  }), {});

  const toggleProduct = (showId: number, productId: number) => {
    const isChecked = selectionMap[showId].has(productId);

    const currentSelection = selection.find(showWithProd => showWithProd.showId === showId);
    let newProductList: number[] = [];
    if (isChecked) {
      newProductList = currentSelection.productIds.filter(id => id !== productId);
    } else {
      newProductList = [productId, ...currentSelection.productIds];
    }

    const selectionsWithoutCurrent = selection.filter(sel => sel.showId !== showId);
    const newSelection: server.dto.LinkShowInstruction = {
      ...currentSelection,
      productIds: newProductList
    };

    setSelection([...selectionsWithoutCurrent, newSelection]);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (isLoading) {
      return;
    }

    setIsLoading(true);

    const documentApi = getDocumentCoreApi(props.documentType);
    documentApi.LinkShows({
      documentId: props.documentId,
      shows: selection
    })
      .then(props.onLinkedShowsSaved);
  };

  if (selection.length === 0) {
    return <Loading />;
  }

  return <>
    <div className="grow1 scrollbox-auto">
      {showWithProducts.map(item => (
        <div key={item.show.showId} className="padding-large gray-100 flex margin-bottom-small">
          <div className="margin-right-small"><AppointmentPhase value={item.show.status.appointmentPhase} displayLabel={false} /></div>
          <div className="grow1">
            <div className="flex-column gap-small">
              <div className="big_text">{item.show.eventDescription}</div>
              {(item.show.venueDescription?.length > 1) && <div className="big_text">@ {item.show.venueDescription}</div>}
              <div>
                <ShowDateTime dateTime={item.show.dateTime} />
              </div>
            </div>

            {(item.products.collection.length > 0) && <div className="margin-top">
              {item.products.collection.map(prod => (
                <SelectProduct
                  key={prod.productId}
                  product={prod}
                  onChecked={(product) => { toggleProduct(item.show.showId, product.productId); }}
                  checked={selectionMap[item.show.showId].has(prod.productId)}
                />
              ))}

            </div>}
          </div>
        </div>
      ))}

    </div>
    <div className="flex justify-end">
      <div>
        <Button loading={isLoading} primary onClick={onSubmit}>{RESX.Buttons.btnSave}</Button>
      </div>
    </div>
  </>;
};

export default SelectShowProducts;
